import $ from 'jquery';

const initMarquee = (el) => {
  const section = $(el);
  const marqueeContent = section.find('.marquee__content');

  const playBtn = section.find('.btn[data-action="marquee-play"]');
  const pauseBtn = section.find('.btn[data-action="marquee-pause"]');

  const playMarquee = () => {
    playBtn.hide();
    pauseBtn.fadeIn(100, () => playBtn.removeClass('active'));
    marqueeContent.addClass('enable-animation').removeClass('pause-animation');

    // Calculate duration for each marquee content separately for consistent speed
    marqueeContent.each((index, contentElement) => {
      const content = $(contentElement);
      const element = content.find('.marquee__content__element').first();
      const elementWidth = element.outerWidth();
      const pixelsPerSecond = 100; // Adjust this to control speed (100 px/second)
      const duration = elementWidth / pixelsPerSecond;
      content.css('--marquee-duration', `${duration}s`);
    });
  };

  const pauseMarquee = () => {
    pauseBtn.hide();
    playBtn.fadeIn(100, () => playBtn.removeClass('active'));
    marqueeContent.addClass('pause-animation');
  };

  if (pauseBtn.length) {
    pauseBtn.hide();
  }

  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  playMarquee();

  playBtn.on('click', playMarquee);

  pauseBtn.on('click', pauseMarquee);

  mediaQuery.addEventListener('change', () => {
    if (mediaQuery.matches) {
      pauseMarquee();
    } else {
      playMarquee();
    }
  });
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstMarquee = {
    attach(context) {
      $('.marquee', context).each((index, element) => initMarquee(element));
    },
  };
}(window, Drupal));
